import { useState, useEffect } from "react"
import { RootState, useAppDispatch } from "../../../redux/store"
import { useSelector } from "react-redux"
import Loading from "../../helpers/Loading/Loading"
import Paged from "./Paged"
import { BsTrash } from "react-icons/bs"
import { obtenerCiudadesConsulta, obtenerMisDestinatarios } from "../../../redux/actions/actionsConsulta"
import "../../../styles/misDestinatarios.css"

const MisDestinariosContent = () => {
    const misDestinariosStore = useSelector((state: RootState) => state.consulta.misDestinatariosConsultas)
    const ciudadesStore = useSelector((state: RootState) => state.consulta.ciudadesConsulta)
    const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
    const dispatch = useAppDispatch()
    const [input, setInput] =useState("")
  
    function estadoInicial(){
        dispatch(obtenerCiudadesConsulta())
        buscarDestinatarios("")
        setInput("")
    }
    function buscarDestinatarios(query: string){
        dispatch(obtenerMisDestinatarios(usuarioVM._ItemActivo.id, query))
    }
    
    function handleBusqueda(e: React.FormEvent<HTMLFormElement>)  {
        e.preventDefault()
        buscarDestinatarios(input)
    }

    function handleEnter(e: React.KeyboardEvent<HTMLInputElement>){
        if(e.key === "Enter"){
            e.preventDefault()
            buscarDestinatarios(input)
        }
    }

    let haBuscado = false 
    
    useEffect(() => {
        if(!haBuscado){
            estadoInicial()
            haBuscado = true
        }
    }, []);

    return(
       
    <div id="content" className="main-content">
        <div className="layout-px-spacing">  
            <div className="row layout-spacing layout-top-spacing" id="cancel-row">
                <div className="col-lg-12">
                            <div className="d-flex justify-content-center mb-2">
                                <h3 className="text-center p-1">Consulta Mis Destinatarios</h3>
                            </div>
                    <div className="widget-content searchable-container list d-flex- justify-content-center">
                                <form className="mb-3 d-flex justify-content-center"  onSubmit={(e) => handleBusqueda(e)}>
                                    <div className="d-flex align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                        <input 
                                            type="text" 
                                            className="form-control input-buscarDestinatario ml-2"
                                            placeholder="Buscar Destinatario..."
                                            onKeyDown={(e) => handleEnter(e)}
                                            value={input}
                                            onChange={(e) => setInput(e.target.value)}
                                        />
                                        <button className="btn-trash-misDestinarios">
                                            <BsTrash/>
                                        </button>
                                    </div>
                                </form>
                        {misDestinariosStore.loading === false && ciudadesStore.loading === false?
                        <Paged
                            misDestinatario={misDestinariosStore.info} 
                            ciudades={ciudadesStore.info}
                        />
                        : <Loading/>
                     }
                    </div>
                </div>
            </div>
        </div>
    </div>

)
}


export default MisDestinariosContent